<template>
    <div v-if="showUsagePopup === true">
        <div>
            <div class="row mainRow">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="floater col-lg-4 col-md-4 col-sm-4 col-xs-12 usage-statement-left">
                        <img :src="headerImage" class="logo" alt="Logo" />
                        <br />
                        <label><span v-html="CompanyAddress"></span></label><br />
                        <a v-bind:href="'http://' + CompanyURL" target="_blank">{{CompanyURL}}</a>
                    </div>

                    <div class="floaterRight col-lg-offset-3 col-lg-5 col-md-offset-3 col-md-5 col-sm-offset-3 col-sm-5 col-xs-12 usage-statement-right">
                        <div class="pad-bottom-5"><b>{{ $t("message.statementDate") }}:</b> {{StartDateString + ' - ' + EndDateString}}</div> <br />
                        <div class="pad-bottom-5">{{customerInfo.CustomerFullName}}</div><br />
                        <div class="pad-bottom-5"><b>{{ $t("message.account") }}: </b>{{customerInfo.AccountNumber}}</div><br />
                        <div class="pad-bottom-5"><b>{{ $t("message.address") }}: </b><label v-html="CustomerPremiseAddress"></label></div>
                    </div>                    
                </div>
            </div>

            <div>&nbsp;</div>

            <div class="row mainRow">
                <div class="floater divDetails col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label><b>{{ $t("message.currentCharges") }}</b></label><br />
                    <table cellspacing="0" class="table table-striped">
                        <tbody>
                            <tr>
                                <td class="usageBreakdown">
                                    {{ $t("message.usageCharge") }}
                                </td>
                                <td class="usageBreakdownNumber">
                                    {{ $n(ConsumptionSubTotal.toFixed(2), 'currency') }}
                                </td>
                            </tr>
                            <tr>
                                <td class="usageBreakdown">
                                    {{ $t("message.miscAdjustments") }}
                                </td>
                                <td class="usageBreakdownNumber">
                                    {{ $n(MiscSubTotal.toFixed(2), 'currency') }}
                                </td>
                            </tr>
                            <tr class="totalBar text-bold">
                                <td class="usageBreakdown"> 
                                    {{ $t("message.totalCurrentCharges") }}
                                </td>
                                <td class="usageBreakdownNumber">
                                    {{ $n((ConsumptionSubTotal + MiscSubTotal).toFixed(2), 'currency') }}
                                </td>
                            </tr>
                        </tbody>                        
                    </table>
                </div>
            </div>
        </div>

        <br />
        <div class="row mainRow">
            <div class="floater divDetails col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label><b>{{ServiceType}}</b></label>
                <label><b>{{ $t("message.usage") }}</b></label><br />
                <table class="breakdownTable sideBorders table table-striped text-center" cellspacing="0">
                    <tbody>
                        <tr class="titlerow text-bold">
                            <td>{{ $t("message.meterNum") }}</td>
                            <td>{{ $t("message.servicePeriod") }}</td>
                            <td>{{ $t("message.daysOfService") }}</td>
                            <td>{{ $t("message.startReading") }}</td>
                            <td>{{ $t("message.endReading") }}</td>
                            <td>{{ $t("message.uomUsed", { uom: UOM }) }}</td>
                        </tr>
                        <tr v-for="(usg, index) in Usage" :key="index">
                            <td>
                                {{usg.SerialNo}}
                            </td>
                            <td>
                                {{usg.ServicePeriod}}
                            </td>
                            <td>
                                {{usg.DaysOfService}}
                            </td>
                            <td>
                                {{usg.StartRead}}
                            </td>
                            <td>
                                {{usg.EndRead}}
                            </td>
                            <td>
                                {{usg.TotalConsumption}}
                            </td>
                        </tr>
                        <tr v-if="Usage.length > 1">
                            <td><b>{{ $t("message.total") }}</b></td>
                            <td>&nbsp;</td>
                            <td>
                                <b>{{TotalDaysOfService}}</b>
                            </td>
                            <td>
                                <b>{{TotalkWhUsed}}</b>
                            </td>
                        </tr>
                    </tbody>                    
                </table>

                <label><b>{{ $t("message.consumptionCharges") }}</b></label>
                <table class="breakdownTable table table-striped" cellspacing="0">
                    <tbody>
                        <tr class="titleRow text-bold">
                            <td class="tableColumn1">
                                {{ $t("message.rateName") }}
                            </td>
                            <td class="tableColumn2">
                                {{ $t("message.rateDescription") }}
                            </td>
                            <td class="tableColumn3">
                                {{ $t("message.amountCharged") }}
                            </td>
                        </tr>
                        <tr v-for="(charge, index) in ConsumptionCharges" :key="index">
                            <td class="tableColumn1">
                                {{charge.Name}}
                            </td>
                            <td class="tableColumn2">
                                {{charge.RateDescription}}
                            </td>
                            <td class="tableColumn3">
                                {{ reformatNumber($n(charge.TotalAmount.toFixed(6), 'currency6Decimal'))}}
                            </td>
                        </tr>
                        <tr>
                            <td class="tableColumn1">
                                &nbsp;
                            </td>
                            <td class="tableColumn2">
                                <b>{{ $t("message.subtotal") }}</b>
                            </td>
                            <td class="tableColumn3">
                                <b>{{ reformatNumber($n(ConsumptionSubTotal.toFixed(6), 'currency6Decimal')) }}</b>
                            </td>
                        </tr>
                    </tbody>   
                </table>

                <label><b>{{ $t("message.miscAdjustments") }}</b></label>
                <table class="breakdownTable table table-striped" cellspacing="0">
                    <tbody>
                        <tr class="titleRow text-bold">
                            <td class="tableColumn1">
                                {{ $t("message.itemName") }}
                            </td>
                            <td class="tableColumn2">
                                {{ $t("message.itemAmount")}}
                            </td>
                            <td class="tableColumn3">
                                {{ $t("message.amountCharged") }}
                            </td>
                        </tr>
                        <tr v-for="(charge, index) in MiscAdjustments" :key="index">
                            <td class="tableColumn1">
                                {{charge.Name}}
                            </td>
                            <td class="tableColumn2">
                                {{charge.RateDescription}}
                            </td>
                            <td class="tableColumn3">
                                {{ reformatNumber($n(charge.TotalAmount.toFixed(6), 'currency6Decimal')) }}
                            </td>
                        </tr>
                        <tr>
                            <td class="tableColumn1">
                                &nbsp;
                            </td>
                            <td class="tableColumn2">
                                <b>{{ $t("message.subtotal") }}</b>
                            </td>
                            <td class="tableColumn3">
                                <b>{{ reformatNumber($n(MiscSubTotal.toFixed(6), 'currency6Decimal')) }}</b>
                            </td>
                    </tbody>

                </table>
                <label v-if="ReconicleAdjusts"><b>{{ $t("message.End Of Cycle Adjustment") }}</b></label>
                <table v-if="ReconicleAdjusts" class="breakdownTable table table-striped" cellspacing="0">
                    <tbody>
                        <tr class="titleRow text-bold">
                            <td class="tableColumn1">
                                {{ $t("message.Adjustment") }}
                            </td>
                            <td class="tableColumn3">
                                {{ $t("message.Amount") }}
                            </td>
                        </tr>
                        <tr v-for="(charge, index) in ReconicleAdjusts" :key="index">
                            <td class="tableColumn1">
                                {{charge.Name}}
                            </td>
                            <td class="tableColumn2">
                                {{reformatNumber($n(charge.TotalAmount.toFixed(6), 'currency6Decimal'))}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import router from "../../router/index";
    import {store} from "../../store/index";

    export default {
        router,
        name: "UsagePopup",
        props: {
            billingCycleAssignmentID: 0,
            premiseId: 0,
        },
        data() {
            //There's no need to define this, I do it for my own reference.
            return {
                ServiceType: '',
                StartDateString: '',
                EndDateString: '',
                CompanyAddress: '',
                CustomerPremiseAddress: '',
                CompanyURL: '',
                GrandTotal: 0,
                TotalDaysOfService: 0,
                TotalkWhUsed: 0,
                Usage: [],
                ConsumptionCharges: [],
                MiscAdjustments: [],
                ReconicleAdjusts: [],
                customerInfo: {},
                headerImage: '',
                UOM: '',
                showUsagePopup: false
            }
        },
        computed:
        {
            ConsumptionSubTotal: function()
            {
                var rtn = 0;
                for (var index = 0, len = this.ConsumptionCharges.length; index < len; index++)
                {
                    rtn += parseFloat(this.ConsumptionCharges[index].TotalAmount || 0);
                }
                return rtn;
            },
            MiscSubTotal: function()
            {      
                var rtn = 0;
                for (var index = 0, len = this.MiscAdjustments.length; index < len; index++)
                {
                    rtn += parseFloat(this.MiscAdjustments[index].TotalAmount || 0);
                }
                return rtn;
            },
            ReconcileSubTotal: function()
            {
                var rtn = 0;
                for (var index = 0, len = this.ReconicleAdjusts.length; index < len; index++)
                {
                    rtn += parseFloat(this.ReconicleAdjusts[index].TotalAmount || 0);
                }
                return rtn;
            }
        },
        methods: {
            reformatNumber: function(num)
            {
                if (num.length > 0)
                {
                    //Turns - to ()
                    if (num.charAt(0) === "-")
                    {
                        num = "(" + num.substr(1) + ")";
                    }
                }
                return num;
            },
            runUsage()
            {
                var self = this;
                this.customerInfo = this.$store.getters.getCustomerInfo;
                this.headerImage = this.$store.getters.getHeaderImage;
                //When you call the usage statement from an object, you need to call this.  This does the "true" mounting.  You'll need a premiseId and/or
                //BillingCycleID... if you leave defaults, -1 BillingCycle means "current cycle", -1 PremiseID means "current premise".
                axios({
                    method: "POST",
                    data: {
                        billingCycleAssignmentID: this.billingCycleAssignmentID === 0 ? -1 : this.billingCycleAssignmentID,
                        premiseId: this.premiseId === 0 ? -1 : this.premiseId
                    },
                    url: this.$httpAxiosBaseUrl() + "Usagestatement/GetUsageStatement"
                }).then(result => {
                    result = result.data;
                    self.ServiceType = result.ServiceType;
                    self.StartDateString = result.StartDateString;
                    self.EndDateString = result.EndDateString;
                    if (result.CompanyAddress !== undefined) {                
                        self.CompanyAddress = result.CompanyAddress.replace(/\n/g, "<br />");
                    }
                    if (result.CustomerPremiseAddress !== undefined) {
                        self.CustomerPremiseAddress = result.CustomerPremiseAddress.replace(/\n/g, " ");
                    }
                    self.CompanyURL = result.CompanyURL;
                    self.GrandTotal = result.GrandTotal;
                    self.TotalDaysOfService = result.TotalDaysOfService;
                    self.TotalkWhUsed = result.TotalkWhUsed;
                    self.Usage = result.Usage;
                    self.ConsumptionCharges = result.ConsumptionCharges;
                    self.MiscAdjustments = result.MiscAdjustments;
                    self.ReconicleAdjusts = result.ReconicleAdjusts;
                    self.UOM = result.UnitOfMeasure;
                    //All of these run at the same time, but this one is inevitably the slowest.
                    self.showUsagePopup = true;
                });
            }
        },
        watch: {
            premiseId: function(val)
            {
                if (val !== 0)
                {
                    this.runUsage();
                }
            },
            billingCycleAssignmentID: function(val)
            {
                if (val !== 0)
                {
                    this.runUsage();
                }
            }
        }

    }


</script>

<!-- Any changes to this css should also be reflected in UsageStatementModal.vue usageCss property, so it will go to printer/pdf properly -->    
<style scoped>
.usage-statement-left .logo {
    max-height: 85px;
}

.usage-statement-right {
    border: 1px solid #f1f1f1;
    padding: 10px;
    margin-top: 10px;
}

    .usage-statement-right div.pad-bottom-5 {
        display: inline-block;
    }

.tableColumn1 { 
    width: 50%;
}

.tableColumn2 { 
    width: 30%;
}

.tableColumn3 { 
    width: 20%;
}
</style>